
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate-agents-insurance",
      function () {
        return require("private-next-pages/real-estate-agents-insurance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate-agents-insurance"])
      });
    }
  